import { getImageSrcSet } from './getImageSources'

// One place to build a slide's srcset, so an off-DOM preload asks the CDN for
// exactly the candidates the rendered <img> will, and the browser can reuse it.
export const getSlideSrcSet = (src: string, widths: number[]) => {
  return (
    getImageSrcSet(
      src,
      widths.map((width) => {
        return {
          width: String(width),
          intrinsicImageSize: String(width),
        }
      })
    ) ?? undefined
  )
}
